module.exports = __webpack_public_path__ + "static/media/wcp_cyc_lan.d5fa80e0.png";